import React from 'react';
import { useIntl } from 'umi';

import './index.scss';
const NoData = (props: any) => {
  const { formatMessage } = useIntl();
  const { text = formatMessage({ id: 'common_nodata' }), style } = props;
  return <div className="no-data" style={style} dangerouslySetInnerHTML={{ __html: text }} />;
};

export default NoData;
